import React, { useState, useEffect, forwardRef } from "react";
import MaterialTable from "material-table";
import { Add, DeleteOutlineOutlined } from "@material-ui/icons";
import api from "../services/api";

export default function MaterialTableDemo() {
  const [state, setState] = useState({
    columns: [
      { title: "Nome", field: "name" },
      { title: "E-mail", field: "email" },
      {
        title: "Setor",
        field: "SectorId",
        lookup: {}
      }
    ],
    data: [],
    msgError: null,
    msgSuccess: null,
    isEmail: null
  });

  useEffect(() => {
    searchSectors();
  }, []);

  const isValidId = value => {
    const validIds = [5, 6, 21];
    if (validIds.indexOf(value) !== -1) {
      return true;
    }
    return false;
  };

  const searchSectors = async () => {
    const sectors = await api.get(`/sectors?status=1`);
    let secs = sectors.data.rows.reduce((accumulator, currentValue) => {
      if (isValidId(currentValue.id)) {
        accumulator[currentValue.id] = currentValue.name;
      }
      return accumulator;
    }, {});

    const instructors = await api.get(`/instructors`);
    let columns = state.columns;
    columns[2].lookup = secs;
    setState({ ...state, columns: columns, data: instructors.data });
  };

  async function saveAndSearchSectors(res) {
    setState({
      ...state,
      msgSuccess: res.data.msg
    });
    await searchSectors();
  }

  function setErrorsIntoState(errors) {
    setState({
      ...state,
      msgError: errors
    });
  }

  const createInstructor = async newData => {
    await api
      .post(`/instructors`, newData)
      .then(async res => {
        await saveAndSearchSectors(res);
      })
      .catch(({ response }) => {
        console.log("entrou no error");

        console.log("TCL: updateInstructor -> response", response.data);
        setErrorsIntoState(
          response.data.errors
            ? response.data.errors[0].msg
            : "Por favor verifique os dados preenchidos"
        );
      });
  };

  const updateInstructor = async (newData, oldData) => {
    if (isEmail(newData.email)) {
      const newInstructor = {
        ...newData,
        phone: newData.phone !== "" ? newData.phone : null
      };
      await api
        .patch(`/instructors/${oldData.id}`, newInstructor)
        .then(async res => {
          console.log("entrou no then");

          await saveAndSearchSectors(res);
        })
        .catch(({ response }) => {
          console.log("entrou no error");

          console.log("TCL: updateInstructor -> response", response.data);
          setErrorsIntoState(response.data);
        });
    }
  };

  const deleteInstructor = async oldData => {
    await api
      .delete(`/instructors/${oldData.id}`)
      .then(async res => {
        await saveAndSearchSectors(res);
      })
      .catch(({ response }) => {
        setErrorsIntoState(response.data);
      });
  };
  const isEmail = email => {
    var usuario = email.substring(0, email.indexOf("@"));
    var dominio = email.substring(email.indexOf("@") + 1, email.length);
    if (
      usuario.length >= 1 &&
      dominio.length >= 3 &&
      usuario.search("@") == -1 &&
      dominio.search("@") == -1 &&
      usuario.search(" ") == -1 &&
      dominio.search(" ") == -1 &&
      dominio.search(".") != -1 &&
      dominio.indexOf(".") >= 1 &&
      dominio.lastIndexOf(".") < dominio.length - 1
    ) {
      setState({ isEmail: true });
      return true;
    } else {
      setState({ isEmail: false });
      setErrorsIntoState([{ msg: "Necessário ser um e-mail válido" }]);

      return false;
    }
  };

  const tableIcons = {
    Add: forwardRef((props, ref) => (
      <Add {...props} ref={ref} color="primary" />
    )),
    Delete: forwardRef((props, ref) => (
      <DeleteOutlineOutlined {...props} ref={ref} color="error" />
    ))
  };

  return (
    <>
      <MaterialTable
        title=""
        icons={tableIcons}
        options={{
          actionsColumnIndex: 5
        }}
        localization={{
          pagination: {
            labelDisplayedRows: "{from}-{to} de {count}",
            labelRowsSelect: "linhas",
            firstTooltip: "Primeira",
            previousTooltip: "Anterior",
            nextTooltip: "Próxima",
            lastTooltip: "Última"
          },
          body: {
            emptyDataSourceMessage: "Não há dados a serem exibidos",
            editRow: {
              saveTooltip: "Salvar",
              cancelTooltip: "Cancelar",
              deleteText: "Tem certeza que deseja deletar este registro?"
            },
            addTooltip: "Adicionar",
            deleteTooltip: "Deletar",
            editTooltip: "Editar"
          },
          header: {
            actions: "Ações"
          },
          toolbar: {
            nRowsSelected: "{0} linha(s) selecionada(s)",
            searchPlaceholder: "Pesquisar"
          }
        }}
        columns={state.columns}
        data={state.data}
        editable={{
          onRowAdd: newData => createInstructor(newData),
          onRowUpdate: async (newData, oldData) =>
            updateInstructor(newData, oldData),
          onRowDelete: oldData => deleteInstructor(oldData)
        }}
      />
      {state.msgError || state.msgSuccess ? (
        <div
          className={
            state.msgSuccess ? "alert alert-success" : "alert alert-danger"
          }
        >
          {state.msgError}
          {state.msgSuccess}
        </div>
      ) : null}
    </>
  );
}
